export const NEW_LET_ELIGIBILITY_QUESTION = {
  text: "Is this policy to be purchased in conjunction with a new tenancy agreement, or replacing an existing equivalent policy?",
  accordionLabel: "What does this mean",
  expandContent: `<p>Please answer <strong>yes</strong> if this policy is either:</p>
    <ul>
      <li>To begin prior to, or on the start date of a new tenancy agreement, or</li>
      <li>Is directly replacing a comparable policy meaning there is no break in cover between the cancellation date of the existing policy and start date.</li>
    </ul>`,
  warningText:
    "As you have answered no to this question, please be aware that any dispute arising within the first 90 days of the policy is excluded.",
  checkboxLabel: "I confirm that I have read this to the applicant.",
};

export const QUOTE_ELIGIBILITY = [
  {
    id: "1",
    text: "Your property will not be permanently occupied by anybody other than you and/or your family. Family means you, your partner and any other person permanently living with you (including children or foster children). Excludes lodgers and any other tenants not covered under your tenancy agreement.",
  },
  {
    id: "2",
    text: "The property does not have signs of or has never had any damage caused to it by landslip, subsidence, or heave.",
  },
  {
    id: "3",
    text: "You or any member of your family to be insured do not have any unspent convictions or prosecutions pending (other than motor convictions).",
  },
  {
    id: "4",
    text: "You or any member of your family have not had insurance cancelled, declined, declared void, or had any special terms imposed.",
  },
  {
    id: "5",
    text: "The home or the land belonging to it has not flooded in the last 10 years.",
  },
  {
    id: "6",
    text: "The property will not be left unoccupied for a total of more than 60 days in a row.",
  },
  {
    id: "7",
    text: "The property will not be used for business or professional purposes, other than clerical work undertaken by you and your family.",
  },
];

export const HOME_ELIGIBILITY = [
  {
    id: "1",
    text: "Your property will not be permanently occupied by anybody other than you and/or your family. Family is defined as you, your partner and any other person permanently living with you (including any children or foster children). Excludes lodgers and any other tenants not covered under your tenancy agreement.",
  },
  {
    id: "2",
    text: "The property does not have signs of or has never had any damage caused to it by landslip, subsidence or heave.",
    expandContent:
      "<p class='mb-4 mt-4'>If your property has suffered a claim for landslip, subsidence or heave, we will not be able to provide cover. If you are unsure, this information can normally be found within a previous property survey. Please see below for descriptions of each.</p><p> Landslip - Downward movement of sloping ground. <br />Subsidence - Downward movement of the ground beneath the buildings, other than by settlement. <br />Heave - Upward movement of the ground beneath the buildings as a resultof the soil expanding.</p>",
    eventTextDisplayOpen: "Find out more",
    iconOpen: "mdi-chevron-down",
    eventTextDisplayClose: "Show less",
    iconClose: "mdi-chevron-up",
  },
  {
    id: "3",
    text: "You or any member of your family to be insured do not have any unspent convictions or prosecutions pending (other than motor convictions).",
  },
  {
    id: "4",
    text: "You or any member of your family have not had any insurance cancelled, declined, declared void, or had any special terms imposed.",
  },
  {
    id: "5",
    text: "The home or the land belonging to it has not flooded in the last 10 years.",
  },
  {
    id: "6",
    text: "The property will not be left unoccupied for a total of more than 60 days in a row.",
  },
  {
    id: "7",
    text: "The property will not be used for business or professional purposes, other than clerical work undertaken by you and your family.",
  },
];

export const LANDLORD_ELIGIBILITY_COVER = [
  {
    id: "1",
    text: "The property will only be used for residential purposes by the tenant(s)?",
    expandContent:
      '<p class="mb-0">The property must only be used for residential purposes and this should be reflected in the tenancy agreement</p>',
    eventTextDisplay: "Help with residential purposes",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
  {
    id: "2",
    text: "The property will only be let to tenants aged 18 or over?",
    expandContent:
      '<p class="mb-0">All tenants noted on the tenancy agreement must be aged 18 or over</p>',
    eventTextDisplay: "Help with tenant age",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
  {
    id: "3",
    text: "An acceptable tenancy agreement will be in place for the duration of this policy?",
    expandContent: `<p>An agreement between the landlord and the tenant in relation to the property which is:</p>
      <p class="ml-4">a) An assured periodic tenancy in accordance with Part 1 of the Renters’ Rights Act 2025, as amended from Section 5 of the Housing Act 1988 (as amended) or</p>
      <p class="ml-4">b) The Housing (Scotland) Act 1988 or a private residential tenancy (as defined in the Private Housing (Tenancies) (Scotland) Act 2016); or</p>
      <p class="ml-4">c) The Private Tenancies (Northern Ireland) Order 2006; or</p>
      <p class="ml-4">d) A standard occupation contract under the Renting Homes (Wales) Act 2016 or</p>
      <p class="ml-4 mb-0">e) A Company Residential Tenancy (Company Let) created after 28th February 1997 where the tenant is a public limited company (plc) or limited company (Ltd) and the property is let purely for residential purposes of the tenant's employees and their family.</p>`,
    eventTextDisplay: "What is an acceptable tenancy agreement?",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
  {
    id: "4",
    text: "A satisfactory tenant reference been carried out on the tenant(s) or guarantor?",
    expandContent: `<p>The following checks must be carried out before the commencement of the tenancy agreement or the policy, whichever is later;</p>
    <p>A credit check against the tenant and any guarantor, obtained from a licensed credit referencing company showing:</p>
    <p class="ml-4">a) no County Court Judgments in the past three years and</p>
    <p class="ml-4">b) no outstanding County Court Judgments, together with copies of two forms of identification, one of which must contain a photograph, and</p>
    <p class="ml-4">c) an employers’ written confirmation of their permanent and current employment, and</p>
    <p class="ml-4">d) that their gross monthly salary is at least a multiple of 2.5 of the rent and</p>
    <p class="ml-4">e) they have a permanent ’right to rent’ in England or the ’right to reside’ in the territorial limits.</p>
    <p>If all of the above are not available or in the case of student tenants or tenants receiving any income or housing related government benefit, a full tenant reference showing a ’pass’ on the tenant or guarantor must be obtained from one of the approved tenant referencing providers listed on the Arc Legal website;</p>
    <p class="mb-0"><a href="https://claims.arclegal.co.uk/info/approved-tenant-referencing-providers" target="_blank" rel="noopener noreferrer">https://claims.arclegal.co.uk/info/approved-tenant-referencing-providers</a></p>`,
    eventTextDisplay: "Help with tenant references",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
  {
    id: "5",
    text: "The first month’s rent has been paid, or will be paid before allowing the tenant(s) into possession of the property?",
    expandContent: `<p class="mb-0">The first month's rent must have been received in cash or cleared funds</p>`,
    eventTextDisplay: "Help with rent payments",
    iconOpen: "mdi-chevron-right",
    iconClose: "mdi-chevron-down",
  },
];

export const LANDLORD_ELIGIBILITY = [
  {
    id: "1",
    text: "When occupied the property will be let under a tenancy agreement directly between the letting agent or landlord and each tenant.",
  },
  {
    id: "2",
    text: "The property will not be used for any other purpose than residential.",
  },
  {
    id: "3",
    text: "The property does not have any signs of, or ever had any damage caused to it by landslip, subsidence or heave.",
  },
  {
    id: "4",
    text: "You or any member of your family do not have any unspent convictions or pending prosecutions.",
  },
  {
    id: "5",
    text: "You or any member of your family have not had insurance cancelled, declined or declared void or had any special terms applied.",
  },
  {
    id: "6",
    text: "There will not be more than 6 individual tenants occupying the property.",
  },
  {
    id: "7",
    text: "The property is not a bedsit or divided into individual self-contained units each with individual cooking facilities.",
  },
  {
    id: "8",
    text: "The property or the land belonging to it has not flooded in the last 10 years.",
  },
];

export const B2B_BUSINESS_LANDLORD_ELIGIBILITY = [
  {
    id: "1",
    text: "When occupied the property will be let under a tenancy agreement directly between the letting agent or landlord and each tenant.",
  },
  {
    id: "2",
    text: "The property will not be used for any other purpose than residential.",
  },
  {
    id: "3",
    text: "The property does not have any signs of, or ever had any damage caused to it by landslip, subsidence or heave.",
  },
  {
    id: "4",
    text: "You or any principal, director or partner involved with the business do not have any unspent convictions or pending prosecutions.",
  },
  {
    id: "5",
    text: "You or any principal, director or partner involved with the business have not had insurance cancelled, declined or declared void or had any special terms applied.",
  },
  {
    id: "6",
    text: "There will not be more than 6 individual tenants occupying the property.",
  },
  {
    id: "7",
    text: "The property is not a bedsit or divided into individual self-contained units each with individual cooking facilities.",
  },
  {
    id: "8",
    text: "The property or the land belonging to it has not flooded in the last 10 years.",
  },
];

export const LANDLORD_COMPANY_ELIGIBILITY = [
  {
    id: "1",
    text: "When occupied the property will be let under a tenancy agreement directly between the letting agent or landlord and each tenant.",
  },
  {
    id: "2",
    text: "The property will not be used for any other purpose than residential.",
  },
  {
    id: "3",
    text: "The property does not have any signs of, or ever had any damage caused to it by landslip, subsidence or heave.",
  },
  {
    id: "4",
    text: "You or any principal, director or partner involved with the limited company do not have any unspent convictions or pending prosecutions.",
  },
  {
    id: "5",
    text: "You or any principal, director or partner involved with the limited company have not had insurance cancelled, declined or declared void or had any special terms applied.",
  },
  {
    id: "6",
    text: "There will not be more than 6 individual tenants occupying the property.",
  },
  {
    id: "7",
    text: "The property is not a bedsit or divided into individual self-contained units each with individual cooking facilities.",
  },
  {
    id: "8",
    text: "The property or the land belonging to it has not flooded in the last 10 years.",
  },
];

export const TENANTS_CONTENTS_ELIGIBILITY = [
  {
    id: "1",
    text: "You do not have any unspent convictions or prosecutions pending (excluding motor convictions).",
  },
  {
    id: "2",
    text: "You’ve never had insurance cancelled, declined, declared void or had any special terms imposed because of a non-disclosure of information, fraudulent activity or misrepresentation.",
  },
  {
    id: "3",
    text: "The property will not be left unoccupied for more than 60 days in a row.",
  },
  {
    id: "4",
    text: "The property will not be used for business or professional purposes, other than clerical work.",
  },
];

export const TENANTS_LIABILITY_ELIGIBILITY = [
  {
    id: "1",
    text: "This property is my main residence and is within the United Kingdom.",
  },
  {
    id: "2",
    text: "I am currently a tenant with a tenancy agreement in place for this property.",
  },
  {
    id: "3",
    text: "I do not have Tenants Liability Insurance cover on another policy.",
  },
];

export const MPPI_ELIGIBILITY = [
  {
    id: "1",
    text: "You're aged 18 years or over but under 64 years at the policy start date. Your cover will stop when you reach 65 years of age.",
  },
  {
    id: "2",
    text: "You’re currently a resident of the UK.",
  },
  {
    id: "3",
    text: "You're actively working at least 16 hours per week. This must be paid work, this includes self-employed work, statutory maternity and parental leave, but does not include temporary work.",
  },
  {
    id: "4",
    text: "Your work is not temporary, casual, seasonal, irregular or a period of training/apprenticeship. This must be paid work, this includes self-employed work, statutory maternity and parental leave, but does not include temporary work.",
  },
  {
    id: "5",
    text: "You’re named on the mortgage agreement for the residential property which is your main home.",
  },
  {
    id: "6",
    text: "You're paying or about to pay a mortgage agreement for a residential property which is permanently occupied by you and your immediate family as your home. The mortgage start date must be within 30 days of the policy start date.",
  },
  {
    id: "7",
    text: "You are up to date with your repayments of any existing mortgage agreements.",
  },
  {
    id: "8",
    text: "You understand the pre-existing medical conditions exclusion of this policy. Pre-existing medical conditions are any conditions (whether specifically diagnosed or not) which the customer knew about, or should reasonably have known about at the policy start date, or which they received treatment for or had seen or arranged to see a doctor about during the 12 months immediately before the policy start date.",
  },
];

export const RENT_PROTECTION_ELIGIBILITY = [
  {
    id: "1",
    text: "<b>You have an insurable interest in the property?</b>",
    expandContent: `<p class="mt-4">In order to purchase this policy, the applicant must own the insured property or is responsible for the property on behalf of the landlord.</p>`,
  },
  {
    id: "2",
    text: "<b>The property will only be used for residential purposes by the tenant(s)?</b>",
    expandContent: `<p class="mt-4">The property must only be used for residential purposes and this should be reflected in the tenancy agreement</p>`,
  },
  {
    id: "3",
    text: "<b>The property will only be let to tenants aged 18 or over?</b>",
    expandContent: `<p class="mt-4">All tenants noted on the tenancy agreement must be aged 18 or over</p>`,
  },
  {
    id: "4",
    text: "<b>An acceptable tenancy agreement will be in place for the duration of this policy, these are:</b>",
    expandContent: `<p class="mt-4">a) An agreement between the landlord and the tenant in relation to the property which is:</p>
    <p class="mt-3">b) An assured periodic tenancy in accordance with Part 1 of the Renters’ Rights Act 2025, as amended from Section 5 of the Housing Act 1988 (as amended) or</p>
    <p class="mt-3">c) The Housing (Scotland) Act 1988 or a private residential tenancy (as defined in the Private Housing (Tenancies) (Scotland) Act 2016); or</p>
    <p class="mt-3">d) The Private Tenancies (Northern Ireland) Order 2006; or</p>
    <p class="mt-3">e) A standard occupation contract under the Renting Homes (Wales) Act 2016 or</p>
    <p class="mt-3">f) A Company Residential Tenancy (Company Let) created after 28th February 1997 where the tenant is a public limited company (plc) or limited company (Ltd) and the property is let purely for residential purposes of the tenant’s employees and their family.</p>`,
  },
  {
    id: "5",
    text: "<b>A satisfactory tenant reference has been carried out on the tenant(s) or guarantor?</b>",
    expandContent: `<p class="mt-4">The following checks must be carried out before the commencement of the tenancy agreement or the policy, whichever is later;</p>
    <p class="mt-3">A credit check against the tenant and any guarantor, obtained from a licensed credit referencing company showing:</p>
    <p class="mt-3">a) no County Court Judgments in the past three years and</p>
    <p class="mt-3">b) no outstanding County Court Judgments, together with copies of two forms of identification, one of which must contain a photograph (<a href="https://www.paymentshield.co.uk/identification" target="_blank" rel="noopener noreferrer">https://www.paymentshield.co.uk/identification</a>), and</p>
    <p class="mt-3">c) an employers' written confirmation of their permanent and current employment, and</p>
    <p class="mt-3">d) that their gross monthly salary is at least a multiple of 2.5 of the rent and</p>
    <p class="mt-3">e) they have a permanent 'right to rent' in England or the 'right to reside' in the territorial limits.</p>
    <p class="mt-3">If all of the above are not available or in the case of student tenants or tenants receiving any income or housing related government benefit, a full tenant reference showing a 'pass' on the tenant or guarantor must be obtained from one of the approved tenant referencing providers listed on the Arc Legal website; <a href="https://claims.arclegal.co.uk/info/approved-tenant-referencing-providers" target="_blank" rel="noopener noreferrer">https://claims.arclegal.co.uk/info/approved-tenant-referencing-providers</a></p>`,
  },
  {
    id: "6",
    text: "<b>The first month's rent has been paid, or will be paid before allowing the tenant(s) into possession of the property?</b>",
    expandContent: `<p class="mt-4">The first month's rent must have been received in cash or cleared funds.</p>`,
  },
];

export const TENANTS_CONTENTS_ELIGIBILITY_INFO_MSG =
  "To continue with your quote or purchase you must confirm the following are true for you, your partner and any other person permanently living with you under your tenancy agreement:";
export const QUOTE_ELIGIBILITY_INFO_MSG =
  "To proceed with this quotation, you must be able to confirm you meet all of the below eligibility criteria.";
export const HOME_ELIGIBILITY_INFO_MSG =
  "Please confirm that you meet all of the below eligibility criteria. Take care to make sure that the information you provide is accurate to the best of your knowledge, otherwise your insurance provider could increase your premium, refuse a claim or void your policy.";
export const LANDLORD_ELIGIBILITY_INFO_MSG =
  "Please confirm that you meet all of the below eligibility criteria. Take care to ensure that the information you provide is accurate to the best of your knowledge, otherwise your premium could increase, your claim may be refused or your policy could be voided";
export const MPPI_ELIGIBILITY_INFO_MSG =
  "To continue with the quote, you must confirm the following statements are true for all applicants and make sure they are fully aware of the eligibility requirements.";
export const RENT_PROTECTION_ELIGIBILITY_INFO_MSG =
  "To proceed with this quotation, you must be able to confirm you meet all of the below eligibility criteria.";
